<template>
    <el-dialog
        title="Pre-fill from campaign"
        :visible.sync="showForm"
        append-to-body
        @closed="reset">

        <el-row class="mt-10" v-if="loadingCampaigns">
            <el-col :span="24">
                <el-alert
                    type="info"
                    :closable="false">
                    <i class="fad fa-spinner-third fa-spin fa-2x spinned-icon"></i>Loading employer's campaigns ...
                </el-alert>
            </el-col>
        </el-row>

        <el-row class="mt-10">
            <el-col :span="24">
                <el-select
                    v-model="campaignId"
                    filterable
                    clearable
                    multiple
                    :trigger-on-focus="false"
                    class="full-width"
                    :disabled="employer_id === null || campaigns.length === 0"
                    placeholder="Select a campaign">
                    <el-option
                        v-for="item in campaigns"
                        :key="`campaign-${item.id}`"
                        :label="`${item.name}` + (item.jobs_count === 0 ? ' (no active jobs)' : '')"
                        :value="item.id"
                        :disabled="item.jobs_count === 0">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
            <btn :click="() => showForm = false" cssClass="btn-default" icon="fal fa-times">Close</btn>
            <btn :click="prefill" cssClass="btn-primary" :disabled="campaignId.length === 0">Pre-fill from campaign</btn>
        </span>

    </el-dialog>
</template>

<script>
export default {
    props: [
        'show',
        'employer_id',
    ],
    data() {
        return {
            campaignId: [],
            campaigns: [],
            loadingCampaigns: false,
        };
    },
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) { this.$emit('close'); },
        },
    },
    watch: {
        show: function (val) {
            if (val) {
                this.loadCampaigns();
            } else {
                this.reset();
            }
        },
    },
    methods: {
        prefill() {
            this.$emit('prefill', { campaign_id: this.campaignId });
            this.showForm = false;
        },
        reset() {
            this.campaignId = [];
            this.campaigns = [];
        },
        loadCampaigns() {
            const self = this;
            self.loadingCampaigns = true;
            axios.get(url(`admin/employer/${self.employer_id}/campaigns/detail-dropdown`))
                 .then((response) => {
                     self.campaigns = response.data;
                     self.loadingCampaigns = false;
                 });
        },
    },
}
</script>

<style scoped>
.mt-10 {
    margin-top: 10px;
}

.full-width {
    width: 100%;
}

.spinned-icon {
    position: relative;
    top: -3px;
    left: -7px;
}
</style>